import { LoadCase, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { LoadGroupSchema } from './LoadGroupSchema';

export const LoadCaseSchema = new ModelSchema<LoadCase>('loadCase', {
  category: ModelCategory.ComponentDesignData,

  children: {
    loadGroups: LoadGroupSchema,
  },

  properties: {},

  displayName: (loadCase) => {
    const manualLoadIndicator = loadCase.loads.some((load) => load.isManualLoad) ? '*' : '';
    return `${loadCase.index}.${manualLoadIndicator} ${loadCase.name}`;
  },
  preSorted: true,
});
